import { FC } from 'react'
import { Link } from 'react-router-dom'
import { CountUp } from './CountUp'

type TimesheetToday = {
    clocked_in: number
    on_break: number
    completed: number
    holiday: number
    sick: number
    absent: number
    not_clocked_in: number
}

type Props = {
    data: {
        today: TimesheetToday
        totalEmployees: number
        hoursToday: number
        hoursThisWeek: number
    }
}

/**
 * Live "Workforce Today" panel — headcounts mirror the Who's In page (GetWhosIn),
 * fed by the dashboard-stats `timesheet` block. Links to the live Who's In view.
 */
export const WorkforceTodayPanel: FC<Props> = ({ data }) => {
    const t = data.today
    const off = (t.holiday || 0) + (t.sick || 0) + (t.absent || 0)

    const tiles = [
        { key: 'in', label: 'Clocked In', value: t.clocked_in, dot: 'in', title: 'Currently working' },
        { key: 'break', label: 'On Break', value: t.on_break, dot: 'break', title: 'On a break' },
        { key: 'done', label: 'Completed', value: t.completed, dot: 'done', title: 'Finished for the day' },
        { key: 'off', label: 'Off', value: off, dot: 'off', title: `Holiday ${t.holiday || 0} · Sick ${t.sick || 0} · Absent ${t.absent || 0}` },
        { key: 'out', label: 'Not In', value: t.not_clocked_in, dot: 'out', title: 'Not clocked in today' },
    ]

    return (
        <div className="gc-workforce gc-reveal">
            <div className="gc-workforce-head">
                <h3 className="gc-workforce-title">
                    Workforce Today <span className="gc-live-dot" />
                </h3>
                <Link to="/admin/timesheet/whos-in" className="gc-workforce-link">
                    View Who's In <i className="bi bi-arrow-right"></i>
                </Link>
            </div>
            <div className="gc-workforce-body">
                {tiles.map((tile) => (
                    <div className="gc-wf-tile" key={tile.key} title={tile.title}>
                        <div className="gc-wf-tile-top">
                            <span className={`gc-wf-dot gc-wf-dot--${tile.dot}`}></span>
                            <span className="gc-wf-label">{tile.label}</span>
                        </div>
                        <div className="gc-wf-value gc-num">
                            <CountUp value={tile.value} />
                        </div>
                    </div>
                ))}
                <div className="gc-wf-hours">
                    <div className="gc-wf-hours-row">
                        <span className="gc-wf-hours-label">Hours Today</span>
                        <span className="gc-wf-hours-val gc-num">
                            <CountUp value={data.hoursToday} decimals={1} />
                            <small>h</small>
                        </span>
                    </div>
                    <div className="gc-wf-hours-divider"></div>
                    <div className="gc-wf-hours-row">
                        <span className="gc-wf-hours-label">This Week</span>
                        <span className="gc-wf-hours-val gc-num">
                            <CountUp value={data.hoursThisWeek} decimals={1} />
                            <small>h</small>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}
